import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Checkbox, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { getVendors, getVendorFeatures, updateVendorFeatures } from '../api/client';

// GET returns canonical feature names; PUT accepts the *_enabled request
// fields. Keep the UI state canonical and translate only at save time.
const FEATURES = [['drowsiness', 'Drowsiness'], ['yawning', 'Yawning'], ['distracted', 'Distracted'], ['presence', 'Presence'], ['screenshot', 'Screenshot Monitoring'], ['browser_history', 'Browser History Monitoring']];

export default function VendorFeaturesPage() {
  const [vendors, setVendors] = useState([]);
  const [values, setValues] = useState({});
  const [error, setError] = useState('');
  useEffect(() => { getVendors().then(async list => {
    setVendors(list);
    const rows = await Promise.all(list.map(async vendor => [vendor.id, await getVendorFeatures(vendor.id)]));
    setValues(Object.fromEntries(rows));
  }).catch(e => setError(e.response?.data?.detail || 'Unable to load permissions')); }, []);
  const save = async (vendorId) => {
    try {
      const payload = Object.fromEntries(FEATURES.map(([key]) => [`${key}_enabled`, Boolean(values[vendorId]?.[key])]));
      const updated = await updateVendorFeatures(vendorId, payload);
      setValues(v => ({ ...v, [vendorId]: updated }));
    }
    catch (e) { setError(e.response?.data?.detail || 'Unable to save permissions'); }
  };
  return <Box sx={{ p: 3 }}><Typography variant="h5" fontWeight={700} mb={2}>Vendor Feature Permissions</Typography>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    <Paper><Table><TableHead><TableRow><TableCell>Vendor</TableCell>{FEATURES.map(([, label]) => <TableCell key={label}>{label}</TableCell>)}<TableCell>Last Updated</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
      <TableBody>{vendors.map(vendor => <TableRow key={vendor.id}><TableCell>{vendor.name}</TableCell>{FEATURES.map(([key, label]) => <TableCell key={key}><Checkbox checked={Boolean(values[vendor.id]?.[key])} onChange={e => setValues(v => ({ ...v, [vendor.id]: { ...v[vendor.id], [key]: e.target.checked } }))} inputProps={{ 'aria-label': label }} /></TableCell>)}<TableCell>{values[vendor.id]?.updated_at || 'Never'}</TableCell><TableCell><Button onClick={() => save(vendor.id)} variant="contained">Save</Button></TableCell></TableRow>)}</TableBody></Table></Paper>
  </Box>;
}
